import type {ReactElement} from 'react';
import React from 'react';
import styles from './captured-image.module.scss';
import {useAppSelector} from '@/hooks';

interface CapturedImageProps {
  imageSrc: string | undefined;
  isOnMobile?: boolean;
}

export function CapturedImage({isOnMobile = false, ...props}: CapturedImageProps): ReactElement | null {
  const selectedCamera = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.selectedCamera;
  });

  return (
    <div className={`flex-center _full-width _full-height ${styles.frame}`}>
      <img
        src={props.imageSrc}
        alt="Captured"
        className={`${isOnMobile ? '_full-width _full-height' : 'radius-4'} ${styles.capturedImage}  ${selectedCamera !== 'environment' ? styles.mirror : ''}`}
      />
    </div>
  );
}
